<template>
  <div class="fish">
    <img :src="fish | fishImg" /><br>
    <span>{{fish[lang]}}</span>
  </div>
</template>

<script>
import fb from 'firebase'

export default {
  props: {
    key: null,
    lang: null
  },
  data: function() {
    return {
      fish: {}
    }
  },
  ready: function() {
    let self = this

    fb.database().ref('fishes/' + this.key)
    .on('value', function(snapshot) {
      self.fish = snapshot.val()
    })

  }
}
</script>



/** WEBPACK FOOTER **
 ** Fish.vue?36a8701c
 **/